import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";

// svg
import { ReactComponent as IconCheck } from "../../assets/svg/check.svg";
import { StepContent } from "@mui/material";

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  /* common colour rules (active & completed) */
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#343745",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#343745" /* "#efa21e" */,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "#c7c7d6",
    borderTopWidth: 2,
    borderRadius: 4,
  },

  /* horizontal + alternativeLabel */
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
    /* [`& .${stepConnectorClasses.line}`]: {
      borderTopWidth: 2,
      borderColor: '#c7c7d6',
      borderRadius: 4,
    }, */
  },

  /* vertical */
  [`&.${stepConnectorClasses.vertical}`]: {
    marginLeft: 10,
    [`& .${stepConnectorClasses.line}`]: {
      borderLeftWidth: 2,
      borderColor: "#c7c7d6",
      borderRadius: 0,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: "#343745",
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: "#343745",
      },
    },
  },

  /* [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      color: "#efa21e",
    },
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#efa21e",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#efa21e",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "#c7c7d6",
    borderTopWidth: 2,
    borderRadius: 4,
    ...theme.applyStyles("dark", {
      borderColor: "#c7c7d6",
    }),
  }, */
}));

const QontoStepIconRoot = styled("div", {
  shouldForwardProp: (prop) => prop !== "active",
})(({ theme, active, completed }) => ({
  color: active ? "#efa21e" : "#c7c7d6",
  display: "flex",
  height: 22,
  width: "24px",
  alignItems: "center",
  justifyContent: "center",
  "& .QontoStepIcon-completedIcon": {
    color: "#efa21e",
    zIndex: 1,
    fontSize: 18,
  },
  "& .QontoStepIcon-circle": {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor",
    marginRight: "2px",
  },
  ...theme.applyStyles("dark", {
    color: theme.palette.grey[700],
  }),
  /* variants: [
    {
      props: ({ ownerState }) => ownerState.active,
      style: {
        color: "#efa21e",
      },
    },
  ], */
}));

function QontoStepIcon({ active, completed, className }) {
  return (
    <QontoStepIconRoot active={active} completed={completed} className={className}>
      {completed ? (
        <IconCheck stroke="#343745" className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

export const StepperCustom = ({
  steps,
  activeStep = 0,
  orientation = "horizontal",
  children,
  withContent = false,
}) => {
  return (
    <Stepper
      alternativeLabel={orientation === "horizontal"}
      activeStep={activeStep}
      connector={<QontoConnector />}
      orientation={orientation}
    >
      {steps.map((label) => (
        <Step
          key={label}
          sx={{
            "& .MuiStepLabel-label": {
              color: "#c7c7d6", // Just text label
            },
            "& .MuiStepLabel-label.Mui-completed": {
              color: "#343745", // Just text label (COMPLETED)
            },
            "& .MuiStepLabel-label.Mui-active": {
              color: "#efa21e", // Just text label (ACTIVE)
            },
          }}
        >
          <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
          {withContent ? (
            <StepContent
              sx={{
                "&.MuiStepContent-root": {
                  borderLeft: "2px solid #c7c7d6",
                  marginLeft: '10px'
                },
              }}
            >
              {children}
            </StepContent>
          ) : null}
        </Step>
      ))}
    </Stepper>
  );
};
